import { IMAGEN_SEGUROS_ASEGURAME } from '../../../../utils';

const renderImagenAsegurame = {
  'SEG-DA': (
    <img
      src={IMAGEN_SEGUROS_ASEGURAME.asegurameVehiculo}
      alt="AsegurameVehiculo"
      className="w-10"
      style={{ height: '25px' }}
    />
  ),
  'SEG-V': (
    <img
      src={IMAGEN_SEGUROS_ASEGURAME.asegurameViaje}
      alt="AsegurameViaje"
      style={{ width: '22px', height: '33px' }}
    />
  ),
  'SEG-AEG': (
    <img
      src={IMAGEN_SEGUROS_ASEGURAME.asegurameMedico}
      alt="AsegurameMedico"
      style={{ width: '35px', height: '27px' }}
    />
  ),
  'SEG-ONC': (
    <img
      src={IMAGEN_SEGUROS_ASEGURAME.asegurameOncologicoPlus}
      alt="AsegurameOncologicoPlus"
      style={{ width: '45px', height: '45px' }}
    />
  ),
  'SEG-PLENI': (
    <img
      src={IMAGEN_SEGUROS_ASEGURAME.aseguramePlenisalud}
      alt="AseguramePlenisalud"
      style={{ width: '45px', height: '45px' }}
    />
  ),
  'SEG-PLENI-HILC': (
    <img
      src={IMAGEN_SEGUROS_ASEGURAME.aseguramePlenisalud}
      alt="AseguramePlenisalud"
      style={{ width: '45px', height: '45px' }}
    />
  ),
};
const renderImagenCatolica = {
  'SEG-PLENI-HILC': (
    <img
      src={IMAGEN_SEGUROS_ASEGURAME.aseguramePlenisalud}
      alt="AseguramePlenisalud"
      style={{ width: '45px', height: '45px' }}
    />
  ),
};

// Nota: Agregar las imagenes de la catolica si cambian

export const RENDER_IMAGEN_BY_PROYECT = {
  ASEGURAME: { ...renderImagenAsegurame },
  CATOLICA: { ...renderImagenCatolica },
};

const subMenuMobileAsegurame = [
  {
    ruta: '/conocenos',
    title: 'Conócenos',
    description: 'Nuestra misión es hacer los seguros más accesibles.',
  },
  {
    ruta: '/blog',
    title: 'Blog',
    description: 'Noticias y más para informarte del mundo de los seguros.',
  },
  {
    ruta: '/contactanos',
    title: 'Contáctanos',
    description: '¡Estamos aquí para ayudarte! Comunícate con nosotros.',
  },
  {
    ruta: '/preguntas-frecuentes',
    title: 'Preguntas Frecuentes',
    description: 'Respondemos las dudas que tengas.',
  },
  {
    ruta: '/terminos-condiciones',
    title: 'Terminos y Condiciones',
    description: 'Conoce nuestros términos y condiciones.',
  },
];

const subMenuMobileCatolica = [
  {
    ruta: '/preguntas-frecuentes',
    title: 'Preguntas Frecuentes',
    description: 'Respondemos las dudas que tengas.',
  },
  {
    ruta: '/terminos-condiciones',
    title: 'Terminos y Condiciones',
    description: 'Conoce nuestros términos y condiciones.',
  },
];

export const SUB_MENU_MOBILE = {
  ASEGURAME: subMenuMobileAsegurame,
  CATOLICA: subMenuMobileCatolica,
};
